import styled from '@emotion/styled';

import * as Containers from '../Containers';

import { scrollbar } from '../../../theme/elements/scrollbars';

import { Button } from './Button';

export function ButtonGroup(props) {
  return (
    <Containers.Control>
      <Containers.Select />
      <Containers.Action>
        <ButtonGroupContainer>
          {props.component?.capabilities?.map?.((capabilityId) => {
            const isSingle = props.component.capabilities.length === 1;

            return (
              <Button
                key={capabilityId}
                deviceId={props.deviceId}
                capabilityId={capabilityId}
                isSingle={isSingle}
              />
            );
          })}
        </ButtonGroupContainer>
      </Containers.Action>
    </Containers.Control>
  );
}

const ButtonGroupContainer = styled.div`
  ${scrollbar};
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  padding: 0 68px;
  overflow-y: auto;
`;
